export const GET_ACTIVE_WHEEL_START = 'GET_ACTIVE_WHEEL_START';
export const GET_ACTIVE_WHEEL_SUCCESS = 'GET_ACTIVE_WHEEL_SUCCESS';
export const GET_ACTIVE_WHEEL_FAIL = 'GET_ACTIVE_WHEEL_FAIL';
export const GET_ACTIVE_WHEEL_RESET = 'GET_ACTIVE_WHEEL_RESET';
